module.exports = __webpack_public_path__ + "img/icon-256x256.a3c7f6ba.png";